<wui-preview-table>
  <tr class="wui-preview-table__header">
    <th>{{ 'PEPPOL.Preview.Vat.Rate' | translate }}</th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Vat.Base' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Vat.Tax' | translate }}
    </th>
    <th class="wui-preview-table__cell--right">
      {{ 'PEPPOL.Preview.Vat.Total' | translate }}
    </th>
  </tr>

  @for (vat of vats(); track vat.rate) {
    <tr class="wui-preview-table__body">
      <td>{{ vat.rate }}&nbsp;%</td>
      <td class="wui-preview-table__cell--right">
        {{ vat.base | number: '1.2-2' }}
      </td>
      <td class="wui-preview-table__cell--right">
        {{ vat.tax | number: '1.2-2' }}
      </td>
      <td class="wui-preview-table__cell--right">
        @if (vat.base != null && vat.tax != null) {
          {{ vat.base + vat.tax | number: '1.2-2' }}
        }
      </td>
    </tr>
  }
</wui-preview-table>
